import { OwlCarousel as ReactOwlCarousel } from "./owlCarousel";
import { isValidArray } from "./common";

const CAROUSEL_RESPONSIVE = {
  330: { items: 1 },
  375: { items: 1 },
  430: { items: 3 },
  540: { items: 4 },
  991: { items: 5 },
};

export const ProductCarouselSection = ({
  title,
  headerAction,
  sectionClassName,
  sectionId,
  items,
  renderItem,
  getItemKey,
}) => {
  if (!isValidArray(items)) return null;

  return (
    <section className={sectionClassName} id={sectionId}>
      <div className="container-fluid container-lg">
        <div className="row">
          <div className="col-lg-12">
            <div className={"subcategory-title" + (headerAction ? " subcategory-title-action" : "")}>
              <h4>{title}</h4>
              {headerAction}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <ReactOwlCarousel
              key={`${items.length}-${getItemKey ? getItemKey(items[0], 0) : "carousel"}`}
              className="category-products owl-theme"
              loop={false}
              rewind={false}
              items={4}
              nav
              dots={true}
              autoplay={false}
              responsive={CAROUSEL_RESPONSIVE}
            >
              {items.map((item, index) => (
                <div className="item" key={getItemKey ? getItemKey(item, index) : index}>
                  {renderItem(item)}
                </div>
              ))}
            </ReactOwlCarousel>
          </div>
        </div>
      </div>
    </section>
  );
};
